














































import Vue from 'vue'
import Component from 'vue-class-component'
import { i18n } from '@/Infrastructure/Intl/Intl'

@Component
export default class LanguageSelector extends Vue {
  currentLanguage = 'gl'

  get transformedLanguageCode (): string {
    const language = this.currentLanguage === 'gl'
      ? 'ga'
      : this.currentLanguage
    return language.toUpperCase()
  }

  changeLanguage (languageCode: string) {
    this.currentLanguage = languageCode
    i18n.locale = languageCode
  }
}
